import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,[_c('FCCRefereeApplication',{ref:"appRed",attrs:{"runs":this.runs,"index":this.startId * 2,"red":this.red}}),_c('FCCRefereeApplication',{directives:[{name:"show",rawName:"v-show",value:((this.startId * 2 + 1) < this.runs.length),expression:"(this.startId * 2 + 1) < this.runs.length"}],ref:"appBlue",attrs:{"runs":this.runs,"index":this.startId * 2 + 1,"red":this.red}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }